import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });

// Attach bearer token fallback (robust to cookie SameSite issues).
let TOKEN = localStorage.getItem("smashup_token") || null;
export function setToken(t) {
  TOKEN = t;
  if (t) localStorage.setItem("smashup_token", t);
  else localStorage.removeItem("smashup_token");
}
client.interceptors.request.use((cfg) => {
  if (TOKEN) cfg.headers.Authorization = `Bearer ${TOKEN}`;
  return cfg;
});

export function apiErr(e, fallback = "Something went wrong.") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").join(" ") || fallback;
  return d?.msg || e?.message || fallback;
}

export const api = {
  guest: () => client.post("/auth/guest"),
  register: (b) => client.post("/auth/register", b),
  login: (b) => client.post("/auth/login", b),
  googleSession: (session_id) => client.post("/auth/google/session", { session_id }),
  logout: () => client.post("/auth/logout"),
  me: () => client.get("/auth/me"),
  submitMatch: (b) => client.post("/match/result", b),
  missions: () => client.get("/missions"),
  claimMission: (id) => client.post(`/missions/${id}/claim`),
  daily: () => client.get("/daily"),
  claimDaily: () => client.post("/daily/claim"),
  shop: () => client.get("/shop"),
  shopFeatured: () => client.get("/shop/featured"),
  buy: (cosmeticId) => client.post("/shop/buy", { cosmeticId }),
  equip: (slot, cosmeticId) => client.post("/garage/equip", { slot, cosmeticId }),
  settings: (b) => client.post("/settings", b),
  removeAds: () => client.post("/ads/remove"),
  leaderboard: () => client.get("/leaderboard"),
  seasonLeaderboard: () => client.get("/leaderboard/season"),
  seasonRewards: () => client.get("/season/rewards"),
  claimSeasonRewards: () => client.post("/season/rewards/claim"),
  achievements: () => client.get("/achievements"),
  partyHosted: () => client.post("/achievements/party-host"),
  changeName: (displayName) => client.post("/account/name", { displayName }),
  casinoCrate: (bet) => client.post("/casino/crate", { bet }),
  casinoWheel: (bet) => client.post("/casino/wheel", { bet }),
  casinoScratch: (bet) => client.post("/casino/scratch", { bet }),
  casinoFreeScratch: () => client.post("/casino/free-scratch"),
  salvage: () => client.get("/salvage"),
  salvageCrack: (tier, instant) => client.post("/salvage/crack", { tier, instant }),
  salvageForge: (rarity, overcharge) => client.post("/salvage/forge", { rarity, overcharge }),
  battlepass: () => client.get("/battlepass"),
  claimBattlepass: (tier, track) => client.post("/battlepass/claim", { tier, track }),
  salvageRecycle: (cosmeticId) => client.post("/salvage/recycle", { cosmeticId }),
  casinoFreeSpin: () => client.post("/casino/free-spin"),
  casinoFreeCrate: () => client.post("/casino/free-crate"),
  adsCoinBoost: () => client.post("/ads/coin-boost"),
  getModes: () => client.get("/modes"),
  unlockMultiplayer: () => client.post("/modes/unlock-multiplayer"),
  enterChampions: () => client.post("/modes/enter-champions"),
  casinoLeaderboard: () => client.get("/casino/leaderboard"),
  casinoFeed: () => client.get("/casino/feed"),
  freeCoins: () => client.post("/ads/free-coins"),
  paymentProducts: () => client.get("/payments/products"),
  checkout: (lookup_key) => client.post("/payments/checkout", { lookup_key, origin_url: window.location.origin }),
  paymentStatus: (sid) => client.get(`/payments/status/${sid}`),
  paymentHistory: () => client.get("/payments/history"),
};
